import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/_services/data.service';

@Component({
  selector: 'app-nearby-places-list',
  templateUrl: './nearby-places-list.component.html',
  styleUrls: ['./nearby-places-list.component.scss']
})



export class NearbyPlacesListComponent implements OnInit {
  // list = ['restaurant', 'school', 'synagogue', 'park', 'supermarket'];
  // Icon from assets folder
  list = [
    {
      name: 'restaurant',
      icon: 'restaurant.png'
    },
    {
      name: 'school',
      icon: 'school.png'
    },
    {
      name: 'synagogue',
      icon: 'synagogue.png'
    },
    {
      name: 'park',
      icon: 'park.png'
    },
    {
      name: 'supermarket',
      icon: 'supermarket.png'
    },
  ]


  @Input() routeParams: any;
  @Input() enableCustomMarkers: boolean = false;
  @Input() additionalCategories: [] = [];
  
  @Output() public showMapViewSubMenu = new EventEmitter();
  urlSwitcher: string = '';
  url: string = '';
  currentLanguage: string = 'he';

  constructor(public dataService: DataService, private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.urlSwitcher = this.dataService.wichDesign().urlSwitcher;
    if (this.route.snapshot.queryParams.lang) {
      this.currentLanguage = this.route.snapshot.queryParams.lang;
    }
    this.url = this.urlSwitcher + this.routeParams.id + '/' + this.routeParams.idp + '/nearbyProject?places='
  }
  openMap(item) {
    this.url = this.urlSwitcher + this.routeParams.id + '/' + this.routeParams.idp + '/nearbyProject?places='
    const queryParams = {
      p: item
    };
    this.router.navigate([this.urlSwitcher + this.routeParams.id + '/' + this.routeParams.idp + '/nearbyProject'],
      {
        queryParams: { places: item, lang: this.currentLanguage },
        queryParamsHandling: 'merge', // Merges with existing params without overwriting them
      }
    );
    this.dataService.saveSearchParameters(item);
    if (window.innerWidth < 1200) {
      this.showMapViewSubMenu.emit("false");
    }
  }
  closeMenu() {
    this.showMapViewSubMenu.emit(false);
  }

}
